module.exports = "pegasus/assets/blocks/column-18-theme5.png";